import { render, staticRenderFns } from "./Cytology.vue?vue&type=template&id=0f07e6ec&scoped=true&"
import script from "./Cytology.vue?vue&type=script&lang=js&"
export * from "./Cytology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f07e6ec",
  null
  
)

export default component.exports